module.exports = __webpack_public_path__ + "img/logout-icon.c19aeb59.svg";